import { render, staticRenderFns } from "./BlogDetail.vue?vue&type=template&id=bfa1d4f6&scoped=true&"
import script from "./BlogDetail.vue?vue&type=script&lang=js&"
export * from "./BlogDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetail.vue?vue&type=style&index=0&id=bfa1d4f6&prod&lang=scss&scoped=true&"
import style1 from "./BlogDetail.vue?vue&type=style&index=1&id=bfa1d4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa1d4f6",
  null
  
)

export default component.exports